export interface Notification {
  id: number;
  subject: string;
  content: string;
  user_id: number;
  is_read: 0 | 1 | boolean;
  created_at: string;
  updated_at: string;
}
